import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';

export const FILTER_SETTINGS: DropDownFilterSettings = { caseSensitive: false, operator: 'contains' };
